import { ProfileType } from "@store/profiles/types";

export const isWithSlots = (surveyProfile: ProfileType | undefined) => {
    return surveyProfile?.is_multiple_slot_enabled || false;
};
